import { translateFr as tfr } from "@/i18n";

export function quotaMessage(e) {
  const d = e?.response?.data?.detail;
  if (!d || typeof d !== "object" || !d.code) return null;
  const upgrade = tfr("Passez à une offre supérieure pour augmenter vos capacités.");
  const map = {
    PLAYER_LIMIT_REACHED: `${tfr("Limite de joueurs atteinte pour votre offre")}${d.limit ? ` (${d.used}/${d.limit})` : ""}. ${upgrade}`,
    STORAGE_LIMIT_REACHED: `${tfr("Limite de stockage documents atteinte pour votre offre.")} ${upgrade}`,
    USER_LIMIT_REACHED: `${tfr("Limite d'utilisateurs atteinte pour votre offre.")} ${upgrade}`,
    FEATURE_NOT_INCLUDED: tfr("Cette fonctionnalité n'est pas incluse dans votre offre."),
    SUBSCRIPTION_INACTIVE: tfr("Abonnement inactif."),
  };
  return map[d.code] || null;
}
